module.exports = __webpack_public_path__ + "img/foreign-image1.f03fb877.png";